import React, { useRef, useEffect } from "react";
import classes from "./CallOuts.module.css";
import Container from "../../UI/Container/Container";
import image from "../../../assets/images/studentlife-kline--resized.jpg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const CallOuts = (props) => {
  const sectionRef = useRef(0);
  const statOneRef = useRef(0);
  const statTwoRef = useRef(0);
  const statThreeRef = useRef(0);
  const statFourRef = useRef(0);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 50%",
      },
    });

    timeline.to(statOneRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statTwoRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statThreeRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
    timeline.to(statFourRef.current, {
      opacity: 1,
      transform: "translateY(0)",
      duration: 0.75,
      ease: "sine.out",
    });
  });
  return (
    <div ref={sectionRef} className={classes.CallOuts}>
      <img src={image} alt="Kline Center in the evening" />
      <div className={classes.Overlay}>
        <Container>
          <div className={classes.Content}>
            <div className={classes.Row}>
              <div ref={statOneRef} className={classes.Column}>
                <p>State-of-the-art athletics and fitness facilities.</p>
              </div>
              <div ref={statTwoRef} className={classes.Column}>
                <p>230+ All-America student-athletes</p>
              </div>
            </div>
            <div className={classes.Row}>
              <div ref={statThreeRef} className={classes.Column}>
                <p>25 NCAA Division III varsity sports</p>
              </div>
              <div ref={statFourRef} className={classes.Column}>
                <p>
                  More than 60% of student-athletes study abroad
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default CallOuts;
